export default "__VITE_ASSET__bdorR_W1__"